module.exports = __webpack_public_path__ + "static/img/top-01.f6ec705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/top-01.png
// module id = Go3M
// module chunks = 1